export default {"src":"/_next/static/media/0x88f1a5ae2a3bf98aeaf342d26b30a79438c9142e.89afde3e.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};